import React from 'react';
import { Translation } from "react-i18next";
import './ErrorReload.scss'

/**
 * Component that shows the error message when another component failed to be loaded and offers a "reload" button.
 */

type Props = {
    message: string
    reverseOnMobile: boolean,
    onReloadClick: () => void
}

export default function ErrorReload(props: Props) {

    const messageEl = getMessageElement();
    const buttonEl = getButtonElement();

    function getMessage() {
        return props.message
            ? props.message
            : <Translation>{t => t("Unfortunately we could not load this component.")}</Translation>;
    }

    function getMessageElement() {
        return (
            <div className="message">
                <img src='/assets/icons/Warning-Filled Icon.svg' alt="Warning icon" />
                <span>{getMessage()}</span>
            </div>
        );
    }

    function getButtonElement() {
        return (
            <button className="reload-button" onClick={props.onReloadClick}>
                <Translation>{t => t("Reload")}</Translation>
            </button>
        );
    }

    return (

        <div className='error-reload-container'>
            {messageEl}
            {buttonEl}
        </div>
    )
}
